var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteBread({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92555;}\n\t.st1{fill:#EDB980;}\n\t.st2{fill:#E5A157;}\n\t.st3{fill:#FFE9B7;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.16,90.78c0-11.38-11.08-20.65-24.98-21.18v-0.05H87.22v0.05c-13.9,0.53-24.98,9.79-24.98,21.18 c0,4.65,1.87,8.93,5,12.43v31.28c0,5.52,4.47,9.99,9.99,9.99l0,0h59.94c5.52,0,9.99-4.47,9.99-9.99l0,0v-31.28 C150.29,99.71,152.16,95.43,152.16,90.78"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.7,
    y: 103.21,
    className: "st2",
    width: 37.46,
    height: 3.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.7,90.78c0-8.65-8.84-15.71-19.98-16.21c-0.41-0.02-5.82-0.03-6.24-0.03c-11.72,0-21.23,7.27-21.23,16.23 c0,3.98,1.88,7.62,4.99,10.45v30.76c0,4.14,3.35,7.49,7.49,7.49l0,0h22.48c4.14,0,7.49-3.35,7.49-7.49l0,0v-30.77 C112.81,98.39,114.7,94.76,114.7,90.78"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBread);
export default __webpack_public_path__ + "static/media/White_bread.d9ed46f9fb926a009a98097869f50d2f.svg";
export { ForwardRef as ReactComponent };